<template>
  <b-nav-item-dropdown
    class="dropdown-cart mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="cartItems.length"
        class="text-body"
        icon="ShoppingCartIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          Inscribirse
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          {{ cartItems.length }} Curso(s)
        </b-badge>
      </div>
    </li>

    <!-- Cart Items -->
    <vue-perfect-scrollbar
      v-if="cartItems.length"
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <b-media
        v-for="item in cartItems"
        :key="item.name"
      >
        <template #aside>
          <b-img
            src="@/assets/images/illustration/api.svg"
            alt="Imagen de materia"
            rounded
            width="62px"
          />
        </template>
        <!-- <feather-icon
          icon="XIcon"
          class="cart-item-remove cursor-pointer"
          @click.stop="removeItemFromCart(item)"
        /> -->
        <div>
          <h6 class="cart-item-title m-0">
            <b-link class="text-body">
              {{ item.nombre }}
            </b-link>
          </h6>
          <small class="cart-item-by">Clave <b class="text-primary">{{ item.clave }}</b></small>
        </div>

        <!-- <h5 class="cart-item-price">
          ${{ item.price }}
        </h5> -->
      </b-media>
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li
      class="dropdown-menu-footer"
    >
      <transition name="fade">
        <div v-if="cartItems.length">
          <!-- <div class="d-flex justify-content-between mb-1">
          <h6 class="font-weight-bolder mb-0">
            Total:
          </h6>
          <h6 class="text-primary font-weight-bolder mb-0">
            ${{ totalAmount }}
          </h6>
        </div> -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            block
            :to="{ name: 'e-commerce-checkout' }"
          >
            Ver inscripciones
          </b-button>
        </div>
        <div v-else>
          <p
            v-if="!cartItems.length"
            class="m-0 pb-1 text-center"
          >
            Aún no agenda ningún curso
          </p>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            block
            to="/tienda"
          >
            Buscar inscripciones
          </b-button>

        </div>
      </transition>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BButton, BImg,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BImg,
    // BFormSpinbutton,
    VuePerfectScrollbar,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
    }
  },
  computed: {
    cartItems() {
      return this.$store.state.eCommerce.cartItems
    },
    totalAmount() {
      let total = 0
      this.cartItems.forEach(i => { total += i.price })
      return total
    },
  },
  methods: {
    removeItemFromCart(productId) {
      this.$store.dispatch('eCommerce/removeProductFromCart', productId)
    },
  },
}
</script>

<style>

</style>
